import type React from "react";
import {MenuItem, TextField} from "@mui/material";
import type {ContractVersion} from "../contractExplorerTypes.ts";
import {formatDate} from "../contractExplorerFormat.ts";

type Props = {
    versions: ContractVersion[];
    value: number;
    inForce: number | null;
    onChange: (versionNo: number) => void;
};

const period = (v: ContractVersion) =>
    `${formatDate(v.valid_from)} → ${v.valid_to ? formatDate(v.valid_to) : 'open'}`;

/** Which period of the bundle the Details tab shows; it opens on the version in force. */
export const VersionPicker: React.FC<Props> = ({versions, value, inForce, onChange}) => (
    <TextField
        select
        size="small"
        className="ci-version-picker"
        label="Version"
        value={value}
        onChange={event => onChange(Number(event.target.value))}>
        {versions.map(v => (
            <MenuItem key={v.version_no} value={v.version_no}>
                Version {v.version_no} · {period(v)}{v.version_no === inForce ? ' · in force' : ''}
            </MenuItem>
        ))}
    </TextField>
);
